import { render } from "./PageLinkModal.vue?vue&type=template&id=fc14c168&scoped=true"
import script from "./PageLinkModal.vue?vue&type=script&lang=js"
export * from "./PageLinkModal.vue?vue&type=script&lang=js"

import "./PageLinkModal.vue?vue&type=style&index=0&id=fc14c168&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc14c168"]])

export default __exports__